"use client";

import { getSentry } from "@/lib/analytics/client-sdks";
import { captureExceptionClient } from "@/lib/analytics/posthog-client";
import NextError from "next/error";
import { useEffect } from "react";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    getSentry()?.captureException(error);
    captureExceptionClient(error, {
      source: "web.global-error",
      digest: error?.digest,
    });
  }, [error]);

  return (
    <html lang="en">
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
